"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function weightFunc(weight) {
  // random(0, 1)^(1/w)
  return Math.pow(Math.random(), 1 / weight);
}

exports.weightFunc = weightFunc;

function fromArray(input) {
  // apply weightFunc to the second element of every tuple.
  return input.map(function (tuple) {
    return [tuple[0], weightFunc(tuple[1])];
  });
}

exports.fromArray = fromArray;

function fromObject(input) {
  // apply weightFunc to each value in the object.
  var tuples = [];

  for (var value in input) {
    if (input.hasOwnProperty(value)) {
      tuples.push([value, weightFunc(input[value])]);
    }
  }

  return tuples;
}

exports.fromObject = fromObject;